<template>
  <v-dialog :value="display" max-width="390" @click:outside="hide">
    <v-card>
      <v-card-title class="headline" v-text="title"></v-card-title>
      <v-card-text v-html="message"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" text @click="hide">
          {{ $t("common.cancel") }}
        </v-btn>
        <v-btn text @click="callback">
          {{ $t("common.continue") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Types } from "../../../store/modules/dialog"

export default {
  name: "Dialog",
  computed: {
    title() {
      return this.$store.state.dialog.title
    },
    display() {
      return this.$store.state.dialog.display
    },
    message() {
      return this.$store.state.dialog.message
    },
  },
  methods: {
    hide() {
      this.$store.commit(Types.mutations.HIDE)
    },
    callback() {
      this.$store.state.dialog.callback()
      this.hide()
    },
  },
}
</script>
